module.exports = __webpack_public_path__ + "flyer_background_fall_leaves_067-b8a318625ad18c24c3ad9e543d9a3200.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_fall_leaves_067.jpg
// module id = 1640
// module chunks = 1